import { GroupsTable } from '@/features/configuration-management/groups-management/groups/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';

import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['groupInfo', 'totalSubGroup', 'totalStores', 'status', 'createdDate']),
  desc: z.boolean(),
});

export const GroupSearchSchema = z
  .object({
    sort: z
      .preprocess((val) => {
        if (typeof val === 'string') {
          try {
            return JSON.parse(val);
          } catch {
            return undefined;
          }
        }
        return val;
      }, z.array(sortItemSchema))
      .optional(),
    createdDate: z
      .string()

      .optional(),
    q: z
      .any()
      .optional()
      .transform((val) => (val == null ? undefined : String(val))),

    fetch: z.coerce.number().positive().catch(10),

    page: z.coerce.number().positive().catch(0),
  })
  .passthrough();

export const Route = createFileRoute('/(app)/configuration-management/group-management/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => GroupSearchSchema.parse(search),
});

import GroupSummary from '@/features/configuration-management/groups-management/GroupSummary';
import { GroupSummarySkeleton } from '@/features/configuration-management/groups-management/GroupSummarySkeleton';
import { useGroupsList } from '@/features/configuration-management/groups-management/hooks/useGroupsList';
import { useGroupSummary } from '@/features/configuration-management/groups-management/hooks/useGroupSummary';

function RouteComponent() {
  const { groupsList, pagination, isLoading } = useGroupsList();
  const { summary, isLoading: isLoadingSummary } = useGroupSummary();
  return (
    <>
      {isLoadingSummary ? <GroupSummarySkeleton /> : <GroupSummary data={summary} />}
      <GroupsTable data={groupsList} pagination={pagination} isLoading={isLoading} />
    </>
  );
}
